@if (!loadedPeriodChart && !showNoPeriodData) {
    <div class="fancy-loader submodule"></div>
}
<div class="chart" #periodScoreChart></div>
@if (showNoPeriodData) {
    <div class="no-data">{{ 'risk.periodScoreChart.noDataFound' | transloco }}</div>
}
